import type { AxiosInstance } from "axios";

export const COMMERCIAL_REUSE_PATH =
  "/commercial-picture-request/acquire-reuse/";

export interface ReuseQuote {
  available: boolean;
  reason?: string;
  sourceAcquiredAt?: string | null;
  closed?: boolean;
  reusePrice?: number;
  quoteToken?: string;
  expiresIn?: number;
}

/** 商業登記リユースの候補と料金を確認する。 */
export const getReuseQuote = async (
  client: AxiosInstance,
  corporateNumber: string
): Promise<ReuseQuote> => {
  const { data } = await client.get<ReuseQuote>(COMMERCIAL_REUSE_PATH, {
    params: { corporateNumber },
  });
  return data;
};

/** 確認済みのPDFと解析結果を取得する。同じ操作の再送には同じキーを使う。 */
export const acquireReuse = async (
  client: AxiosInstance,
  corporateNumber: string,
  quoteToken: string,
  idempotencyKey: string
): Promise<void> => {
  await client.post(COMMERCIAL_REUSE_PATH, {
    corporateNumber,
    quoteToken,
    idempotencyKey,
  });
};
